module.exports = __webpack_public_path__ + "img/Metastasis-OVCA_GSE227019.e6921a3a.png";